<script setup> 
  import { onMounted, computed, ref, toRaw } from 'vue';
  import { useConfirmValidateStore } from '../../stores/ConfirmValidateStore';
  import Loader from '../../components/ui/Loader.vue';
  import MenuSurface from '../../components/ui/MenuSurface.vue';
  import ItemSurface from '../../components/ui/ItemSurface.vue';
  import Button from '../../components/ui/Button.vue';
  import { useI18n } from 'vue-i18n';
  import { useBrowseCartStore } from '../../stores/BrowseCartStore';

  const validateStore = useConfirmValidateStore();
  const cartStore = useBrowseCartStore();
  const { t } = useI18n();
  const emits = defineEmits(['closeModal']);
  const props = defineProps({
    cartId: {
      type: Number,
      required: true
    }
  });

  const loading = computed(() => {
    return validateStore.loading;
  });

  const data = computed(() => {
    if(validateStore.data) { return validateStore.data; }
  });

  const initialAttributes = toRaw({
    id: '',
    name: ''
  });
  const selectedItem = ref({
    sub_library: initialAttributes
  });

  const formData = ref({
    name: '',
    sub_library_id: selectedItem.value.sub_library.id
  });

  const clearSelect = () => {
    selectedItem.value.sub_library = initialAttributes;
    formData.value.sub_library_id = '';
  };

  const sendValidate = async () => {
    const params = { sub_library_id: formData.value.sub_library_id }
    await validateStore.saveSubLibrary(props.cartId, params);
    if(!validateStore.errors) {
      cartStore.cart.status = validateStore.success.status;
      emits('closeModal');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const setSelected = (item, type) => {
    if(type === 'sub_library') {
      selectedItem.value.sub_library = item;
      formData.value.sub_library_id = item.id;
    }
  };

  onMounted (async() => {
    await validateStore.fetchDataValidate(props.cartId);

    if(validateStore.data.cart.sub_library.sub_libraries && validateStore.data.cart.sub_library.id) {
      const sub_library = validateStore.data.cart.sub_library.sub_libraries.find((sub_library) => {
        return sub_library.id === validateStore.data.cart.sub_library.id;
      });
      selectedItem.value.sub_library = { id: sub_library.id, name: sub_library.name, address_full: sub_library.address_full };
      formData.value.sub_library_id = sub_library.id;
    }
  });

  const errors = computed(() => {
    if(validateStore.errors) {
      return validateStore.errors;
    }
  });

</script>

<template>
  <div class="row error-container" v-if="errors">
    <div class="error-container--title">
      {{ errors.title  }}
    </div>
    <p>
      {{ errors.details }}
    </p>
  </div>
  <Loader v-if="loading" />
  <div v-if="data && !loading">
    <h1>{{ t('cart.sub_library.sub_libraries') }}</h1>

    <template v-if="data.cart.already_processed">
      {{ data.cart.sub_library?.name }}
    </template>

    <template v-else>
      <MenuSurface :title="t('cart.sub_library.sub_libraries')" :selectedItem="selectedItem.sub_library.name" v-if="data.cart.sub_library.sub_libraries">
        <ItemSurface @click.prevent="clearSelect()" v-if="formData.sub_library_id" :key="0" :value="0" >
          <strong>{{ t('cart.sub_library.none') }}</strong>
        </ItemSurface>
        <ItemSurface v-for="sub_library in data.cart.sub_library.sub_libraries" :key="sub_library.id" :value="sub_library.id" @click.prevent="setSelected(sub_library, 'sub_library')">
          {{ sub_library.name }}
        </ItemSurface>
      </MenuSurface>
    </template>

    <div class="model-buttons">
      <Button type="button" name_button="button" class="button button--primary" @click.prevent="sendValidate">
        {{ t('cart.sub_library.modify') }}
      </Button>
      <Button type="button" name_button="button" class="button button--white" @click.prevent="emits('closeModal')">
        {{ t('cart.sub_library.cancel') }}
      </Button>
    </div>
  </div>
</template>
